import React, { useState, useEffect } from "react";
// import { data } from "../data";
import { Link } from "react-router-dom";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import { useSelector, useDispatch } from "react-redux";
import { detailsProduct } from "../actions/productActions";
import LoadingBox from "../components/loadingBox";
import MessageBox from "../components/messageBox";
import axios from "axios";
import RelatedProducts from "../components/relatedProducts";

function ProductPage(props) {
  const [qty, setQty] = useState(1);
  const [selectedImage, setSelectedImage] = useState("");

  const productDetails = useSelector((state) => state.productDetails);
  const { product, loading, error } = productDetails;
  // console.log(product);

  const productId = props.match.params.id;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(detailsProduct(productId));
  }, [dispatch, productId]);

  const addToCartHandler = () => {
    props.history.push("/cart/" + productId + "?qty=" + qty);
  };

  //related list
  const [items, setItems] = useState([]);
  const [loadingRelated, setLoadingRelated] = useState(false);
  const [errorRelated, setErrorRelated] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingRelated(true);
        const { data } = await axios.get("/api/products/related");
        setLoadingRelated(false);
        setItems(data);
      } catch (err) {
        setErrorRelated(err.message);
        setLoadingRelated(false);
      }
    };
    fetchData();
  }, [setItems]);

  // console.log(items);

  const Ads = "ads";

  return (
    <div>
      <NavBar />
      <div className="banner5">
        <picture>
          <source media="(min-width: 992px)" srcset="/img/33_L.jpg" />
          <img
            src="/img/33_S.jpg"
            className=" img-responsive align-self-center "
            alt="..."
          />
        </picture>
      </div>

      <div className="container pb-5">
        <div className="pt-3 ">
          <Link to="/" className=" text-decoration-none backtohome">
            Back to Result
          </Link>
        </div>
        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <div className="pt-4 ">
            <div className="row details ">
              <div className="col col-md-4">
                <div className=" pb-3 text-center pimg">
                  <img
                    src={selectedImage || product.image}
                    alt={product.name}
                    width={300}
                  />
                </div>
                <div className="pb-3">
                  <ul
                    xs={1}
                    md={2}
                    className=" list-unstyled img_lists list-group list-group-horizontal justify-content-start"
                  >
                    {[product.image, ...product.images].map((x) => (
                      <li className="mb-1 " key={x}>
                        <div
                          className="img_list"
                          type="button"
                          variant="light"
                          onClick={() => setSelectedImage(x)}
                        >
                          <img
                            variant="top"
                            src={x}
                            alt="product"
                            width="80"
                            className="img-thumbnail"
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="col-md-5 product_info">
                <div>
                  <p className="product_name">{product.name}</p>
                  <ul className="list-unstyled">
                    <li>
                      Price:<strong> ${product.price}</strong>
                    </li>
                    <li>
                      <Link className=" text-decoration-none" to="#">
                        {product.numReviews} reviews
                      </Link>
                    </li>

                    <li className="pt-3 fw-bold pb-3">Description</li>
                    <li className="border p-3 bg-light bg-gradient border-secondary rounded shadow-sm show_content">
                      <p>
                        {product.description.slice(0, 200)}
                        <span className="collapse" id="collapseExample">
                          {product.description.slice(
                            201,
                            product.description.length
                          )}{" "}
                          .
                        </span>
                        <a
                          className="btn btn-link fst-italic text-decoration-none"
                          data-bs-toggle="collapse"
                          href="#collapseExample"
                          role="button"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        ></a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-3 actions">
                <div className="card  details_action pt-2">
                  <div className="card-body">
                    <ul className="list-unstyled">
                      <li>
                        <strong>Price:</strong> ${product.price}{" "}
                      </li>
                      <li>
                        Status:
                        {product.countInStock > 0
                          ? " In Stock"
                          : " Out of Stock"}
                      </li>
                      <li className="d-flex">
                        Qty:
                        <div>
                          <select
                            className="form-select qty "
                            value={qty}
                            onChange={(e) => {
                              setQty(e.target.value);
                            }}
                          >
                            {[...Array(product.countInStock).keys()].map(
                              (x) => (
                                <option value={x + 1} key={x + 1}>
                                  {x + 1}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </li>
                    </ul>
                    {product.countInStock > 0 && (
                      <button
                        onClick={addToCartHandler}
                        className="btn btn-warning w-100 "
                      >
                        Add to Cart
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="container pt-3">
              <span className="fw-bold">You May Also Like</span>
              <div className="pb-5 pt-3">
                <div className="row">
                  <div className="col-12 col-md-10  ">
                    {loading ? (
                      <LoadingBox></LoadingBox>
                    ) : error ? (
                      <MessageBox variant="danger">{error}</MessageBox>
                    ) : (
                      <>
                        {items.length === 0 && (
                          <MessageBox>No Product Found</MessageBox>
                        )}

                        <div>
                          <RelatedProducts
                            products={items.filter(
                              (i) =>
                                i.brand.toLowerCase() ===
                                product.brand.toLowerCase()
                            )}
                          ></RelatedProducts>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default ProductPage;

// import React, { useState, useEffect } from "react";
// // import { data } from "../data";
// import { Link } from "react-router-dom";
// import NavBar from "../components/navbar";
// import Footer from "../components/footer";
// import { useSelector, useDispatch } from "react-redux";
// import { detailsProduct } from "../actions/productActions";
// import LoadingBox from "../components/loadingBox";
// import MessageBox from "../components/messageBox";

// function ProductPage(props) {
//   const [qty, setQty] = useState(1);
//   const [selectedImage, setSelectedImage] = useState("");

//   const productId = props.match.params.id;

//   const productDetails = useSelector((state) => state.productDetails);
//   // console.log(productDetails);
//   const { product, loading, error } = productDetails;
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(detailsProduct(productId));
//   }, [dispatch, productId]);

//   const addToCartHandler = () => {
//     // props.history.push(`cart`);
//     // props.history.push(`/cart/${props.match.params.id}?qty=${qty}`);
//     props.history.push("/cart/" + productId + "?qty=" + qty);
//   };

//   return (
//     <div>
//       <NavBar />

//       <div className="container pb-5">
//         <div className="pt-3 ">
//           <Link to="/" className=" text-decoration-none backtohome">
//             Back to Result
//           </Link>
//         </div>
//         {loading ? (
//           <LoadingBox></LoadingBox>
//         ) : error ? (
//           <MessageBox variant="danger">{error}</MessageBox>
//         ) : (
//           <div className="pt-4 ">
//             <div className="row details ">
//               <div className="col col-md-5">
//                 <div className=" pb-3 text-center pimg">
//                   <img
//                     src={selectedImage || product.image}
//                     alt={product.name}
//                     width={300}
//                   />
//                 </div>
//                 <div className="pb-3">
//                   <ul
//                     xs={1}
//                     md={2}
//                     className=" list-unstyled img_lists list-group list-group-horizontal justify-content-start"
//                   >
//                     {[product.image, ...product.images].map((x) => (
//                       <li className="mb-1 " key={x}>
//                         <div
//                           className="img_list"
//                           type="button"
//                           variant="light"
//                           onClick={() => setSelectedImage(x)}
//                         >
//                           <img
//                             variant="top"
//                             src={x}
//                             alt="product"
//                             width="80"
//                             className="img-thumbnail"
//                           />
//                         </div>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>

//               <div className="col-md-4 product_info">
//                 <div>
//                   <p className="product_name">{product.name}</p>
//                   <ul className="list-unstyled">
//                     <li>
//                       Price:<strong> ${product.price}</strong>
//                     </li>
//                     <li>
//                       <Link className=" text-decoration-none" to="#">
//                         {product.numReviews} reviews
//                       </Link>
//                     </li>

//                     <li className="pt-3 fw-bold pb-3">Description</li>
//                     <li className="border p-3 bg-light bg-gradient border-secondary rounded shadow-sm show_content">
//                       <p>
//                         {product.description.slice(0, 200)}
//                         <span className="collapse" id="collapseExample">
//                           {product.description.slice(
//                             201,
//                             product.description.length
//                           )}{" "}
//                           .
//                         </span>
//                         <a
//                           className="btn btn-link fst-italic text-decoration-none"
//                           data-bs-toggle="collapse"
//                           href="#collapseExample"
//                           role="button"
//                           aria-expanded="false"
//                           aria-controls="collapseExample"
//                         ></a>
//                       </p>
//                     </li>
//                   </ul>
//                 </div>
//               </div>

//               <div className="col-md-3 actions">
//                 <div className="card  details_action pt-2">
//                   <div className="card-body">
//                     <ul className="list-unstyled">
//                       <li>
//                         <strong>Price:</strong> ${product.price}{" "}
//                       </li>
//                       <li>
//                         Status:
//                         {product.countInStock > 0
//                           ? " In Stock"
//                           : " Out of Stock"}
//                       </li>
//                       <li className="d-flex">
//                         Qty:
//                         <div>
//                           <select
//                             className="form-select qty "
//                             value={qty}
//                             onChange={(e) => {
//                               setQty(e.target.value);
//                             }}
//                           >
//                             {[...Array(product.countInStock).keys()].map(
//                               (x) => (
//                                 <option value={x + 1} key={x + 1}>
//                                   {x + 1}
//                                 </option>
//                               )
//                             )}
//                           </select>
//                         </div>
//                       </li>
//                     </ul>
//                     {product.countInStock > 0 && (
//                       <button
//                         onClick={addToCartHandler}
//                         className="btn btn-warning w-100 "
//                       >
//                         Add to Cart
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <Footer />
//     </div>
//   );
// }

// export default ProductPage;

{
  /* <RelatedProducts
                      products={items.filter(
                        (i) => i.brand.toLowerCase() === "nike"
                      )}
                    ></RelatedProducts> */
}
